import { Component, Input } from '@angular/core';

const DEFAULT_BUTTON_TEXT = 'copy_link.copy_selectedMediaItem';
@Component({
  selector: 'copy-image-url-button',
  standalone: false,
  templateUrl: './copy-image-url-button.component.html',
  styleUrl: './copy-image-url-button.component.scss',
})
export class CopyImageUrlButtonComponent {
  @Input() link: string;

  buttonText: string = DEFAULT_BUTTON_TEXT;

  copyLink(): void {
    if (!this.link) {
      return;
    }

    navigator.clipboard
      .writeText(this.link)
      .then(() => {
        // Update the button text or state to indicate success if needed
        // For example, you could change the button text to "Copied!" temporarily
        this.buttonText = 'copy_link.copy_success';
        setTimeout(() => {
          // Reset the button text after a short delay
          this.buttonText = DEFAULT_BUTTON_TEXT;
        }, 5000);
      })
      .catch((err) => {
        // Optionally, you can show an error message here
        console.error('Failed to copy link: ', err);
      });
  }
}
